var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70477 8.5C1.70477 4.84876 4.37614 1.8889 7.67146 1.8889C10.9667 1.8889 13.6381 4.84876 13.6381 8.5V9.05343L12.536 7.83226L11.3307 9.16774L14.4905 12.6688L17.6503 9.16774L16.445 7.83226L15.3429 9.05343V8.5C15.3429 3.80517 11.9086 0 7.67146 0C3.43423 0 0 3.80517 0 8.5C0 13.1948 3.43423 17 7.67146 17C9.48444 17 11.1534 16.3021 12.4669 15.1357L11.4006 13.6614C10.3786 14.569 9.08297 15.1111 7.67146 15.1111C4.37614 15.1111 1.70477 12.1512 1.70477 8.5ZM7.06012 6.55948V12.2778H8.82512V4.72224H7.24111L4.89865 6.19424L5.64327 7.50577L7.06012 6.55948Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.d6e55c08d531fefd7d7e3c9d6b0880eb.svg";
export { ForwardRef as ReactComponent };